import React from "react";
import "../styleSheet/main/components/SearchHeader/SearchHeader.css";

const SearchHeader = ({
  title,
  searchTerm,
  onSearchChange,
  searchBy,
  isDropdownOpen,
  toggleDropdown,
  dropdownRef,
  handleSearchByChange,
  dropdownOptions,
  placeholder,
  children,
  searchIcon,
  isSmallScreen,
}) => (
  <div className="header">
    <h1>{title}</h1>
    {children}
    <div className="searching">
      <input
        type="text"
        placeholder={placeholder}
        value={searchTerm}
        onChange={onSearchChange}
      />
      <div
        className="search-icon"
        style={searchIcon ? { backgroundImage: `url(${searchIcon})` } : {}}
      ></div>
      {!isSmallScreen && (
        <div
          className={`dropdown ${isDropdownOpen ? "open" : ""}`}
          ref={dropdownRef}
        >
          <button className="search-toggle-btn" onClick={toggleDropdown}>
            {dropdownOptions.find((opt) => opt.value === searchBy)?.label}
          </button>
          <div className="dropdown-content">
            {dropdownOptions.map((opt) => (
              <button
                key={opt.value}
                className="dropdown-item"
                onClick={() => handleSearchByChange(opt.value)}
              >
                {opt.label}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  </div>
);

export default SearchHeader;
